export default function ($translate, $rootScope) {
    const loadEnums = () => {
        return {
            KEYS: {
                EMPLOYEE_VIEW: 'EMPLOYEE_VIEW',
                EMPLOYEE_MANAGE: 'EMPLOYEE_MANAGE',
                COURSE_VIEW: 'COURSE_VIEW',
                COURSE_MANAGE: 'COURSE_MANAGE',
                COURSE_VIEW_AND_OCCURRENCE_MANAGE: 'COURSE_VIEW_AND_OCCURRENCE_MANAGE',
                COURSE_VIEW_AND_AUTOMATIC_PLANNING_GROUP_MANAGE: 'COURSE_VIEW_AND_AUTOMATIC_PLANNING_GROUP_MANAGE',
                COURSE_ADMINISTRATE: 'COURSE_ADMINISTRATE',
                PLANNING_VIEW: 'PLANNING_VIEW',
                PLANNING_MANAGE: 'PLANNING_MANAGE',
                MATERIALS_MANAGE: 'MATERIALS_MANAGE',
                REPORTS_COURSES_AND_TARGETED_EMPLOYEES_VIEW: 'REPORTS_COURSES_AND_TARGETED_EMPLOYEES_VIEW',
                REPORTS_COURSES_RESULTS_VIEW: 'REPORTS_COURSES_RESULTS_VIEW',
                REPORTS_EMPLOYEE_RESULTS_VIEW: 'REPORTS_EMPLOYEE_RESULTS_VIEW',
                REPORTS_OVERVIEW_VIEW: 'REPORTS_OVERVIEW_VIEW',
                REPORTS_EMPLOYEE_COURSE_PROGRESS_VIEW: 'REPORTS_EMPLOYEE_COURSE_PROGRESS_VIEW',
                PASSED_COURSE_VIEW: 'PASSED_COURSE_VIEW',
                BUDGET_VIEW: 'BUDGET_VIEW',
                BUDGET_MANAGE: 'BUDGET_MANAGE',
                REPORTS_BUDGET_VIEW: 'REPORTS_BUDGET_VIEW',
                NOTIFICATION_TEMPLATES_MANAGE: 'NOTIFICATION_TEMPLATES_MANAGE',
                MY_EMPLOYEE_MANAGE: 'MY_EMPLOYEE_MANAGE',
                ALL_LEARNERS_REPORT_VIEW: 'ALL_LEARNERS_REPORT_VIEW',
                MY_EMPLOYEE_ADD: 'MY_EMPLOYEE_ADD',
                EXTERNAL_SYNC_MANAGE: 'EXTERNAL_SYNC_MANAGE',
                LICENCE_POINT_VIEW: 'LICENCE_POINT_VIEW',
                SALES_MARKETPLACE_USER_OCCURRENCE_MANAGE: 'SALES_MARKETPLACE_USER_OCCURRENCE_MANAGE',
                SALES_MARKETPLACE_COURSE_VIEW: 'SALES_MARKETPLACE_COURSE_VIEW',
                USER_EXTERNAL_REGISTER_MANAGE: 'USER_EXTERNAL_REGISTER_MANAGE',
                MARKETPLACE_INVOICE_EMAIL_TEMPLATES_VIEW: 'MARKETPLACE_INVOICE_EMAIL_TEMPLATES_VIEW'
            },
            LABELS: {
                EMPLOYEE_VIEW: $translate.instant('role.privilege.employeeView'),
                EMPLOYEE_MANAGE: $translate.instant('role.privilege.employeeManage'),
                COURSE_VIEW: $translate.instant('role.privilege.courseView'),
                COURSE_VIEW_AND_OCCURRENCE_MANAGE: $translate.instant('role.privilege.courseViewAndOccurrenceManage'),
                COURSE_VIEW_AND_AUTOMATIC_PLANNING_GROUP_MANAGE: $translate.instant('role.privilege.courseViewAndAutomaticPlanningGroupManage'),
                COURSE_MANAGE: $translate.instant('role.privilege.courseManage'),
                COURSE_ADMINISTRATE: $translate.instant('role.privilege.courseAdministrate'),
                PLANNING_VIEW: $translate.instant('role.privilege.planningView'),
                PLANNING_MANAGE: $translate.instant('role.privilege.planningManage'),
                MATERIALS_MANAGE: $translate.instant('role.privilege.materialManage'),
                REPORTS_COURSES_AND_TARGETED_EMPLOYEES_VIEW: $translate.instant('role.privilege.reportViewCoursesTargetedEmployees'),
                REPORTS_COURSES_RESULTS_VIEW: $translate.instant('role.privilege.reportViewCoursesResult'),
                REPORTS_EMPLOYEE_RESULTS_VIEW: $translate.instant('role.privilege.reportViewEmployeeResult'),
                REPORTS_OVERVIEW_VIEW: $translate.instant('role.privilege.reportViewOverview'),
                REPORTS_EMPLOYEE_COURSE_PROGRESS_VIEW: $translate.instant('role.privilege.reportViewEmployeeCourseProgress'),
                PASSED_COURSE_VIEW: $translate.instant('role.privilege.passedCourseView'),
                BUDGET_VIEW: $translate.instant('role.privilege.budgetView'),
                BUDGET_MANAGE: $translate.instant('role.privilege.budgetManage'),
                REPORTS_BUDGET_VIEW: $translate.instant('role.privilege.reportsViewBudget'),
                NOTIFICATION_TEMPLATES_MANAGE: $translate.instant('role.privilege.notificationTemplatesManage'),
                MY_EMPLOYEE_MANAGE: $translate.instant('role.privilege.myEmployeeManage'),
                ALL_LEARNERS_REPORT_VIEW: $translate.instant('role.privilege.allLearnersReportView'),
                MY_EMPLOYEE_ADD: $translate.instant('role.privilege.myEmployeeAdd'),
                EXTERNAL_SYNC_MANAGE: $translate.instant('role.privilege.externalSyncManage'),
                LICENCE_POINT_VIEW: $translate.instant('role.privilege.licencePointView'),
                SALES_MARKETPLACE_USER_OCCURRENCE_MANAGE: $translate.instant('role.privilege.salesMarketplaceUserOccurrenceManage'),
                SALES_MARKETPLACE_COURSE_VIEW: $translate.instant('role.privilege.salesMarketplaceCourseView'),
                USER_EXTERNAL_REGISTER_MANAGE: $translate.instant('role.privilege.userExternalRegisterManage'),
                MARKETPLACE_INVOICE_EMAIL_TEMPLATES_VIEW: $translate.instant('role.privilege.marketplaceEmailTemplatesView')
            }
        };
    };

    const enums = loadEnums();

    $rootScope.$on('$translateChangeSuccess', () => {
        enums.LABELS = loadEnums().LABELS;
    });
    return enums;
}



// WEBPACK FOOTER //
// ./src/app/enums/role/privilege/index.js